import { Component } from '@angular/core';
import { filter, first, take } from 'rxjs/operators';
import {
  BaseSiteService,

  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService,
  User,
} from '@spartacus/core';
import { LoadStatus } from '@spartacus/organization/administration/core';
import {
  ConfirmationMessageComponent,
  ConfirmationMessageData,
  ItemService,
  MessageService,
  ToggleStatusComponent, DisableInfoService,
} from '@spartacus/organization/administration/components';
import { UigUserItemService } from 'src/app/organization/services/uig-user-item/uig-user-item.service';
import { UigCurrentUserService } from 'src/app/organization/services/uig-current-user/uig-current-user.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-uig-delete-toggle-status',
    templateUrl: './uig-delete-toggle-status.component.html',
    styleUrls: ['./uig-delete-toggle-status.component.scss'],
    host: { class: 'content-wrapper' },
    standalone: false
})
export class UigDeleteToggleStatusComponent<BaseItem> extends ToggleStatusComponent<BaseItem> {
  currentUser: User;
  private userSubscription = new Subscription();
  constructor(
    protected itemService: ItemService<BaseItem>,
    protected messageService: MessageService<ConfirmationMessageData>
    ,
    private uigUserItemService: UigUserItemService,
    protected globalMessage: GlobalMessageService,
    private baseSiteService: BaseSiteService,
    protected routingService: RoutingService,
    private userAccountFacade: UserAccountFacade,
    private translationService: TranslationService, disableInfoService: DisableInfoService<any>,
  ) {
    super(itemService, messageService , disableInfoService);
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        this.currentUser = user;
      });
  }

  toggle(item) {
    if (item.uid === this.currentUser.uid) {
      this.translationService
      .translate('orgUser.messages.deleteCurrentUser')
      .pipe(first())
      .subscribe((text) => {
        this.globalMessage.add(text, GlobalMessageType.MSG_TYPE_ERROR);
      });
    }
    else if (!this.confirmation) {

      this.confirmation = this.messageService.add({
        message: {
          key: 'uigOrgUser.messages.deleteUser.content',
        },
        messageTitle: {
          key: 'uigOrgUser.messages.deleteUser.title',
        },
        confirm: {
          key: 'uigOrgUser.messages.deleteUser.confirm',
        },
        component: ConfirmationMessageComponent,
      });

      this.subscription.add(
        this.confirmation.pipe(first()).subscribe((event) => {
          if (event.close) {
            this.confirmation = null;
          }
          if (event.confirm) {
            this.messageService.close(this.confirmation);
            this.delete(item);
            this.confirmation = null;
          }
        })
      );
    }
  }

  protected delete(item): void {
    this.uigUserItemService
      .deleteUser(item.uid)
      .pipe(
        take(1),
        filter((data) => data.status === LoadStatus.SUCCESS)
      )
      .subscribe((data) => this.redirect());
  }

  protected redirect() {
    this.baseSiteService.getActive().subscribe((data) => {
      const urlLink = data + '/organization/users/';
      location.href = urlLink;
    });
  }

  ngOnDestroy() {
    this.messageService.clear();
    this.confirmation = null;
    this.subscription?.unsubscribe();
    this.userSubscription?.unsubscribe();
  }
}
